var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "player-controls-container"
  }, [_c('div', {
    staticClass: "play-control"
  }, [_c('button', {
    staticClass: "pause-button pure-button video-control-button",
    attrs: {
      "aria-label": _vm.videoPlaying ? 'Pause' : 'Play',
      "tabindex": "0"
    },
    on: {
      "click": _vm.togglePlay
    }
  }, [!_vm.videoPlaying ? _c('play-icon') : _vm._e(), _vm.videoPlaying ? _c('pause-icon') : _vm._e()], 1), _c('div', {
    staticClass: "timeline"
  }, [_c('input', {
    ref: "videoProgressBar",
    staticClass: "progress-background icon-video-timeline focusable",
    attrs: {
      "tabindex": _vm.disableVideoProgress ? '-1' : '0',
      "id": "video-range-slider",
      "type": "range",
      "role": "progressbar",
      "aria-label": ((_vm.disableVideoProgress ? 'Static' : 'Adjustable') + " video progress indicator - " + (Math.round(_vm.videoProgress)) + "%")
    },
    domProps: {
      "value": _vm.videoProgress
    },
    on: {
      "change": _vm.handleVideoSeek
    }
  })])]), _c('div', {
    staticClass: "volume-control"
  }, [_c('button', {
    staticClass: "volume-button pure-button video-control-button",
    attrs: {
      "aria-label": _vm.videoMuted ? 'Unmute' : 'Mute',
      "tabindex": "0"
    },
    on: {
      "click": _vm.toggleAudio
    }
  }, [!_vm.videoMuted ? _c('volume-icon', {
    attrs: {
      "height": "40px",
      "width": "40px"
    }
  }) : _vm._e(), _vm.videoMuted ? _c('muted-icon', {
    attrs: {
      "height": "40px",
      "width": "40px"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "volume-level-control"
  }, [_c('volume-slider', {
    attrs: {
      "sliderStyles": {
        maxHeight: '9px',
        width: '100%'
      }
    }
  })], 1)]), _c('div', {
    staticClass: "cc-control"
  }, [_c('div', {
    staticClass: "cc-size-control",
    style: {
      visibility: !_vm.hasCaptions || !_vm.captionsOn ? 'hidden' : 'visible'
    }
  }, [_c('button', {
    staticClass: "volume-button pure-button cc-control-button",
    attrs: {
      "aria-label": "Decrease caption size",
      "tabindex": "0"
    },
    on: {
      "click": function () {
        return _vm.handleCCSizeChange(false);
      }
    }
  }, [_c('cc-down-icon')], 1), _c('div', {
    staticClass: "cc-size-text",
    attrs: {
      "aria-label": ("Caption size - " + (_vm.captionSizePercentage))
    }
  }, [_vm._v("\n        " + _vm._s(_vm.captionSizePercentage) + "\n      ")]), _c('button', {
    staticClass: "volume-button pure-button cc-control-button",
    attrs: {
      "aria-label": "Increase caption size",
      "tabindex": "0"
    },
    on: {
      "click": function () {
        return _vm.handleCCSizeChange(true);
      }
    }
  }, [_c('cc-up-icon')], 1)]), _c('button', {
    staticClass: "volume-button pure-button video-control-button",
    attrs: {
      "aria-label": _vm.captionsOn ? 'Turn captions off' : 'Turn captions on',
      "tabindex": "0",
      "disabled": !_vm.hasCaptions
    },
    on: {
      "click": _vm.toggleCaptions
    }
  }, [_vm.hasCaptions && !_vm.captionsOn ? _c('cc-on-icon', {
    attrs: {
      "height": "40px",
      "width": "40px"
    }
  }) : _vm._e(), _vm.hasCaptions && _vm.captionsOn ? _c('cc-off-icon', {
    attrs: {
      "height": "40px",
      "width": "40px"
    }
  }) : _vm._e(), !_vm.hasCaptions ? _c('cc-disabled-icon', {
    attrs: {
      "height": "40px",
      "width": "40px"
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "narration-control"
  }, [_c('button', {
    staticClass: "volume-button pure-button video-control-button",
    attrs: {
      "aria-label": _vm.videoNarrationOn ? 'Turn video narration off' : 'Turn video narration on',
      "disabled": !_vm.hasVideoNarration,
      "tabindex": "0"
    },
    on: {
      "click": _vm.toggleVideoNarrationSettings
    }
  }, [_vm.hasVideoNarration && !_vm.videoNarrationOn ? _c('narration-on-icon', {
    attrs: {
      "height": "40px",
      "width": "40px"
    }
  }) : _vm._e(), _vm.hasVideoNarration && _vm.videoNarrationOn ? _c('narration-off-icon', {
    attrs: {
      "height": "40px",
      "width": "40px"
    }
  }) : _vm._e(), !_vm.hasVideoNarration ? _c('narration-disabled-icon', {
    attrs: {
      "height": "40px",
      "width": "40px"
    }
  }) : _vm._e()], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }